module.exports = __webpack_public_path__ + "img/joy_sp_01.6abfa801.png";